<template>
  <div>
    <p>流程图</p>
    <div ref="mountNode" id="mountNode"></div>
  </div>
</template>

<script>
import 'G6'
import '../../assets/js/g6-node'
import { toArray, toTree, removeNode } from '../../assets/js/g6-tool'

export default {
  name: 'minimap',
  data() {
    return {
      graph: null,
      treeDataArr: [
        {
          id: 'start',
          shape: 'start',
          parent: ''
        },
        {
          id: 'add',
          shape: 'addNodeBtn',
          parent: 'start'
        },
        {
          id: 'ss',
          shape: 'addNodeBtn',
          parent: 'add'
        }
      ],
      treeData: {
        roots: [
          {
            id: 'start',
            shape: 'start',
            children: [
              {
                id: 'add',
                shape: 'addNodeBtn'
              }
            ]
          }
        ]
      },
      modules: [] // 功能模块
    }
  },
  mounted() {
    const layout = new G6.Layouts.CompactBoxTree({ direction: 'TB' })
    this.graph = new G6.Tree({
      container: 'mountNode',
      width: this.$refs.mountNode.width,
      height: 500,
      fitView: 'tc',
      layout
    })
    // 箭头
    this.graph.edge({
      style: {
        endArrow: true
      }
    })
    // 节点透明
    this.graph.node({
      style: {
        // 关键形样式（优先级高于color）
        fill: 'transparent',
        stroke: 'transparent'
      }
    })
    // 渲染流程图
    this.render()
    // 添加
    this.graph.on('node:click', ev => {
      this.addCond(ev, [1, 2, 3])
    })
    this.graph.update(this.graph.getEdges()[0].id, { label: 'dfd' })
  },
  computed: {},
  methods: {
    // 生成节点格式
    treeNode() {
      let roots = JSON.parse(JSON.stringify(this.treeDataArr))
      return {
        roots: toTree(roots)
      }
    },
    // 删除节点
    removeNode(nodeId) {
      removeNode(this.treeDataArr, nodeId)
    },
    // 拖动处理
    drag() {
      let node
      let dx
      let dy
      this.graph.on('node:dragstart', ev => {
        const { item } = ev
        const model = item.getModel()
        node = item
        dx = model.x - ev.x
        dy = model.y - ev.y
      })
      this.graph.on('node:drag', ev => {
        node &&
          this.graph.update(node, {
            x: ev.x + dx,
            y: ev.y + dy
          })
      })
      this.graph.on('node:dragend', ev => {
        node = undefined
      })
    },
    // 点击处理
    click() {
      this.graph.on('node:click', ev => {
        this.addNode(ev)
        // this.graph.layout()
      })
    },
    // 添加节点
    addAction(ev) {
      // console.log(ev.item.id)
      // 生成节点id
      let firstNodeId = this.nodeId()
      let secondNodeId = this.nodeId()
      // 处理旧数据的层级关系
      for (let item of this.treeDataArr) {
        if (item.parent === ev.item.id) {
          item.parent = secondNodeId
        }
      }
      // 增加新层级
      this.treeDataArr.push({
        id: firstNodeId,
        shape: 'start',
        parent: ev.item.id
      })
      this.treeDataArr.push({
        id: secondNodeId,
        shape: 'addNodeBtn',
        parent: firstNodeId
      })

      let aa = JSON.parse(JSON.stringify(this.treeDataArr))
      // console.log('tree', toTree(aa))
      console.log('aa', aa)
      console.log('data', this.treeDataArr)
      this.render()
    },
    /**
     * 添加条件
     * ev 事件对象
     *
     **/
    addCond(ev, condition) {
      // console.log(ev.item.id)
      // 生成节点id
      let firstNodeId = this.nodeId() // 条件节点
      let conditionNodeIds = [] // 条件分支节点
      for (let con of condition) {
        conditionNodeIds.push({
          id: this.nodeId(),
          shape: 'addNodeBtn',
          parent: firstNodeId,
          condition: con
        })
      }
      // 处理旧数据的层级关系，让以前的子节点全部转移到第一个条件节点下
      for (let item of this.treeDataArr) {
        if (item.parent === ev.item.id) {
          item.parent = conditionNodeIds[0].id
        }
      }
      // 增加条件节点
      this.treeDataArr.push({
        id: firstNodeId,
        shape: 'start',
        parent: ev.item.id
      })
      // 添加条件分支节点
      for (let item of conditionNodeIds) {
        this.treeDataArr.push(item)
      }

      let aa = JSON.parse(JSON.stringify(this.treeDataArr))
      // console.log('tree', toTree(aa))
      console.log('aa', aa)
      console.log('data', this.treeDataArr)
      this.render()
    },
    // 生成nodeid
    nodeId(type = 'node') {
      let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split(
        ''
      )
      let nodeName = type + '-'
      for (let i = 0; i < 6; i++) {
        nodeName = nodeName + chars[parseInt(Math.random() * 16)]
      }
      return nodeName
    },
    // 渲染流程图
    render() {
      // 渲染流程图
      this.graph.read(this.treeNode())
      // 处理连线
      let edges = this.graph.getEdges()
      for (let item of this.treeDataArr) {
        if (item.condition) {
          // 如果有分支条件则查找，该节点为目标的连线，将条件展示处理
          let edge = edges.find(function(element) {
            return element.target.id == item.id
          })
          this.graph.update(edge.id, { label: item.condition })
        }
      }
      console.log('edges', edges)
    },
    // 改变画布高度
    changeSize() {
      this.graph.changeSize(this.graph.getWidth(), this.graph.getHeight() + 150)
    }
  },
  created() {}
}
</script>

<style scoped>
#mountNode {
  background: #fff;
}
</style>
